import {
    SIGNIN_SUCCESS,
    SIGNOUT_SUCCESS
} from "../actionTypes";

export const signIn = (userId, name, roleId) => async dispatch => {
    console.log(userId, name, roleId);
    dispatch({
        type: SIGNIN_SUCCESS,
        payload: { userId, name, roleId }
    });
};

// Acción para cerrar sesión
export const signOut = () => async dispatch => {
    dispatch({ type: SIGNOUT_SUCCESS });
};

